
<template>
    
        <mars-view :style="{
        borderRadius,
        color: selected
            ? primaryColor
                ? primaryColor
                : '#5183FF'
            : color,
        backgroundColor: selected
            ? backgroundColorSelected
                ? backgroundColorSelected
                : '#f5f9ff'
            : backgroundColor,
        border: selected
            ? '1px solid ' + primaryColor
            : '',
        padding: selected
            ? '6px 4px'
            : '7px 5px',
        fontWeight: selected && selectedBold ? 'bold' : 'normal'
    }" class="tag-item c-font-normal c-line-clamp1"><mars-view class="c-line-clamp1">
        {{ text }}
    </mars-view><c-icon v-if="selectedIcon" v-show="selected" name="check" class="c-gap-left-small"></c-icon></mars-view>
    
</template>

<script>
import Icon from "../Icon/Icon.vue";
export default {
  components: {
    'c-icon': Icon
  },
  props: {
    /**
     * 标签项文案
     */
    text: String,

    /**
     * 是否被选中
     */
    selected: {
      type: Boolean,
      default: false
    },

    /**
     * 圆角弧度
     */
    borderRadius: {
      type: String
    },

    /**
     * 主颜色
     */
    primaryColor: {
      type: String,
      default: '#5183FF'
    },

    /**
     * 文字颜色
     */
    color: {
      type: String,
      default: '#555'
    },

    /**
     * 背景色
     */
    backgroundColor: {
      type: String,
      default: '#f8f8f8'
    },

    /**
     * 被选中后的背景色
     */
    backgroundColorSelected: {
      type: String,
      default: '#f5f9ff'
    },

    /**
     * 边框颜色
     */
    borderColor: {
      type: String,
      default: '#f8f8f8'
    },

    /**
     * 选中后是否加粗
     */
    selectedBold: {
      type: Boolean,
      default: false
    },

    /**
     * 选中后是否显示图标
     */
    selectedIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>

<style scoped>
.tag-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  height: 38px;
  text-align: center;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border-radius: 5px;
}

</style>
